import { PLACE_TYPE_META, type PlaceType } from "~/lib/api";
import type { AccentScheme } from "~/lib/placeAccents";
import { cn } from "~/lib/utils";

interface PlaceSectionHeaderProps {
  type: PlaceType;
  count: number;
  accent: AccentScheme;
  description?: string;
  className?: string;
}

export function PlaceSectionHeader({ type, count, accent, description, className }: PlaceSectionHeaderProps) {
  return (
    <div className={className}>
      <div className="flex items-center gap-3">
        <div className={cn("size-7 rounded-full flex items-center justify-center", accent.bg)}>
          <span className={cn("text-xs font-medium", accent.text)}>{count}</span>
        </div>
        <h2 className="text-lg @2xl:text-2xl font-light text-foreground">{PLACE_TYPE_META[type].labelPlural}</h2>
      </div>
      {description && <p className="mt-3 text-secondary text-sm leading-relaxed">{description}</p>}
    </div>
  );
}
